import { LuMenu } from "react-icons/lu";
import { useMenu } from "../../context/MenuContext";
import * as styled from "./HamburgerIcon.styled"

function HamburgerIcon() {
   const { setShowMenu } = useMenu();
   return (
      <styled.HamburgerIcon onClick={() => setShowMenu(prev => !prev)} aria-label="Відкрити меню">
         <LuMenu size={22} />
      </styled.HamburgerIcon>
   )
};

export default HamburgerIcon;
